var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Home"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col center-text"},[_c('h1',[_vm._v(_vm._s(_vm.WelcomeLabel))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }